import useAppUser from '../../../../hooks/useAppUser';

const useNavigationDropdownTitle = () => {
  const { user } = useAppUser();

  return user?.agency?.name || '';
};

export default useNavigationDropdownTitle;
